<template>
    <div class="modal fade" id="subscription-cancellation-disabled-modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Manage Your Subscriptions</h4>
                </div>
                <div v-if="shown" class="modal-body mb-0 p-0">
                    <p>It looks like this subscriptions is not eligible for cancellation. Do you need help with your
                        growth program? <a class="intercom_launcher" href="#">CLICK HERE</a></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'cancellation-disabled-modal',
    props: {
        shown: {
            type: Boolean,
            required: false,
        },
    },
    watch: {
        shown: {
            immediate: true,
            handler(shown) {
                $('#subscription-cancellation-disabled-modal').modal(shown ? 'show' : 'hide');
            },
        },
    },
    mounted() {
        $('#subscription-cancellation-disabled-modal').on('hidden.bs.modal', () => this.$emit('hide'));
    },
};

// Intercom
// We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/koau9di8'
(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/koau9di8';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
</script>

<style lang="scss" scoped>
.modal {
    background-color: rgba(#000, 0.5);
}

.close {
    top: 14px;
    right: 20px;
}

button {
    margin-bottom: 30px;
}
</style>
